import { call, put } from 'redux-saga/effects'
import { RequestMethods } from 'utils/axios/methods'
import type { PayloadAction } from '@reduxjs/toolkit'
import { Actions_Notifications } from 'redux/modules/notification/Actions'
import { sagaAction_Error } from 'redux/sagas/actions/SagaAction_Error'
import { Actions_CurrentStation } from 'redux/modules/currentStation/Actions'
import { Actions_Modals } from 'redux/modules/modals/Actions'
import { Actions_Stations } from 'redux/modules/stations/Actions'
import { Actions_CurrentParking } from 'redux/modules/currentParking/Actions'

const client = RequestMethods()

export interface ISagaWorker_DeleteStation {
  id: number
}

export default function* SagaWorker_DeleteStation(action: PayloadAction<ISagaWorker_DeleteStation>) {
  const { id } = action.payload

  yield put(Actions_CurrentStation.store.showLoader())

  try {
    yield call(async () => await client.put(`/stations/${id}/remove`))

    yield put(Actions_CurrentParking.store.deleteCurrentParkingStation({ id }))

    yield put(Actions_Stations.saga.getAllStations())

    yield put(Actions_Modals.store.hideModal())

    yield put(
      Actions_Notifications.store.setNotification({
        message: 'Station successfully deleted',
        type: 'Success',
      }),
    )
  } catch (e) {
    yield call(() => sagaAction_Error(e))
  } finally {
    yield put(Actions_CurrentStation.store.hideLoader())
  }
}
